"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteTextField = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const DebtorMenuItem_1 = require("../DebtorMenuItem/DebtorMenuItem");
const MenuItem_1 = require("../MenuItem/MenuItem");
const TextInput_1 = require("../TextInput/TextInput");
const react_autosuggest_1 = __importDefault(require("react-autosuggest"));
const match_1 = __importDefault(require("autosuggest-highlight/match"));
const parse_1 = __importDefault(require("autosuggest-highlight/parse"));
exports.AutoCompleteTextField = (props) => {
    const { value, onChange, onBlur, selectSuggestion, label, minCharCount, error, className, onFocus, variant, wrapContent, helperText, focusInputOnSuggestionClick = false, } = props;
    const [suggestions, setSuggestions] = react_1.useState([]);
    const [isLoading, setIsLoading] = react_1.useState(false);
    return (React.createElement("div", { className: className },
        React.createElement(react_autosuggest_1.default, { suggestions: suggestions, onSuggestionsFetchRequested: onSuggestionsFetchRequested, onSuggestionsClearRequested: onSuggestionsClearRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: renderSuggestion, renderInputComponent: renderInputComponent, onSuggestionSelected: selectSuggestion, shouldRenderSuggestions: shouldRenderSuggestions, focusInputOnSuggestionClick: focusInputOnSuggestionClick, inputProps: {
                value,
                onChange,
                onBlur,
                label,
                error,
                onFocus,
                variant,
                helperText,
            }, theme: {
                container: { position: 'relative' },
                suggestionsContainerOpen: {
                    position: 'absolute',
                    zIndex: 1,
                    left: 0,
                    right: 0,
                    minWidth: '100%',
                    width: `${wrapContent ? 'auto' : 'max-content'}`,
                    boxShadow: '0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)',
                    maxHeight: '250px',
                    overflow: 'auto',
                },
                suggestionsList: {
                    margin: 0,
                    padding: 0,
                    listStyleType: 'none',
                },
            } })));
    function shouldRenderSuggestions(value) {
        return value.trim().length >= (minCharCount || 0);
    }
    function onSuggestionsClearRequested() {
        setSuggestions([]);
    }
    function onSuggestionsFetchRequested(values) {
        return __awaiter(this, void 0, void 0, function* () {
            if (props.getSuggestions) {
                setIsLoading(true);
                let suggestionsResult = yield props.getSuggestions(values.value);
                if (suggestionsResult === 'canceled') {
                    suggestionsResult = suggestions;
                }
                else {
                    setIsLoading(false);
                }
                const max = props.maxResultsDisplayed || 5;
                setSuggestions(suggestionsResult.splice(0, max));
            }
            else {
                const autoCompleteSuggestions = getSuggestions(values.value, props.suggestions);
                setSuggestions(autoCompleteSuggestions);
            }
        });
    }
    function getSuggestions(value, suggestions) {
        const inputValue = value;
        let count = 0;
        return typeof inputValue !== 'string' || inputValue.length === 0
            ? []
            : suggestions.filter((suggestion) => {
                const strippedSuggestion = suggestion.name
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, '');
                const strippedInput = inputValue
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, '');
                const keep = count < (props.maxResultsDisplayed || 5) &&
                    strippedSuggestion.includes(strippedInput);
                if (keep) {
                    count += 1;
                }
                return keep;
            });
    }
    function getSuggestionValue(suggestion) {
        return suggestion;
    }
    function renderInputComponent(inputProps) {
        return (React.createElement("div", null,
            React.createElement(TextInput_1.TextInput, Object.assign({}, inputProps, { isLoading: isLoading, autoComplete: false }))));
    }
    function renderSuggestion(suggestion, params) {
        const matches = match_1.default(suggestion.name, params.query);
        const parts = parse_1.default(suggestion.name, matches);
        switch (props.type) {
            case 'debtor':
                return React.createElement(DebtorMenuItem_1.DebtorMenuItem, { debtorInfo: suggestion });
            case 'unformatted':
                return React.createElement(MenuItem_1.MenuItem, null, suggestion.name);
            default:
                return (React.createElement(MenuItem_1.MenuItem, null, parts.map((part, index) => (React.createElement("span", { key: String(index), style: { fontWeight: part.highlight ? 500 : 300 } }, part.text)))));
        }
    }
};
//# sourceMappingURL=AutoCompleteTextField.js.map